import { useColorImage } from "../../data/useColorImages";
import React from "react";
import { Button, Image, Modal } from "react-bootstrap";
import Loading from "../helpers/Loading";
import AddColorModal from "../modals/AddColorModal";
import BulkColorModal from "./colorsPage/BulkColorModal";
import ColorsList from "./colorsPage/ColorsList";
import useColorsPageController from "./colorsPage/useColorsPageController";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function ColorsPage() {
  const {
    t,
    columns,
    colors,
    loading,
    canModify,
    insertLoading,
    sortArrow,
    handleSort,
    handleRowClick,
    getMillingNames,
    tableContainerRef,
    showColorModal,
    editingColor,
    closeColorModal,
    openColorModal,
    showBulkModal,
    setShowBulkModal,
    handleBulkInsert,
    fullscreenImage,
    setFullscreenImage
  } = useColorsPageController();

  const fullPreview = useColorImage(fullscreenImage || null);

  return (
    <div className="pb-5 overflow-hidden">
      <div className="container d-xl-block">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h1 className="mb-0">{t("colors")}</h1>
          {canModify && (
            <div>
              <Button
                variant="primary"
                onClick={openColorModal}
                className="me-2"
              >
                {t("addColor")}
              </Button>
              <Button
                variant="success"
                onClick={() => setShowBulkModal(true)}
                disabled={insertLoading}
              >
                {t("bulkImport") || "Tömeges import"}
              </Button>
            </div>
          )}
        </div>
        <BulkColorModal
          show={showBulkModal}
          onHide={() => setShowBulkModal(false)}
          onInsert={handleBulkInsert}
          insertLoading={insertLoading}
        />
        <AddColorModal
          show={showColorModal}
          colorToEdit={editingColor}
          onHide={closeColorModal}
        />
        {loading ? (
          <Loading />
        ) : colors.length === 0 ? (
          <div className="p-3 text-center text-muted">{t("noColors")}</div>
        ) : (
          <ColorsList
            colors={colors}
            columns={columns}
            t={t}
            canModify={canModify}
            sortArrow={sortArrow}
            onSort={handleSort}
            onRowClick={handleRowClick}
            getMillingNames={getMillingNames}
            onImageClick={setFullscreenImage}
            tableContainerRef={tableContainerRef}
          />
        )}
        <Modal show={!!fullscreenImage} onHide={() => setFullscreenImage("")}>
          <Modal.Body>
            {fullPreview?.imageError && <p role="alert">A teljes k?p bet?lt?se sikertelen.</p>}
            <Image
              src={`data:image/jpeg;base64,${fullPreview?.imageData || fullscreenImage?.imageDataReduced || ""}`}
              alt="Fullscreen"
              fluid
            />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
